<button
  mat-fab
  color="primary"
  class="fab fab-fixed-right"
  (click)="addAccomodation()"
  *ngIf="!itineraryService.isItineraryReadOnlyForCurrentUser(itinerary)"
>
  <mat-icon>add</mat-icon>
</button>

<app-empty-list-message
  *ngIf="itinerary.reservations.accomodations.length == 0"
  message="Per questo itinerario non è ancora stata inserita alcuna sistemazione."
  actionIcon="add"
  actionLabel="Aggiungi una sistemazione"
  (actionClick)="addAccomodation()"
  [disabled]="itineraryService.isItineraryReadOnlyForCurrentUser(itinerary)"
>
  <p>
    <small
      >Per gli alloggi, utilizza ove possibile
      <a href="https://www.booking.com" target="_blank">Booking.com</a>.</small
    >
  </p>
  <p>
    <small>Ricordati di aggiungere 3 opzioni per ogni pernottamento.</small>
  </p>
  <p
    style="
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
"
  >
    <small
      ><b>Quale link inserire?</b> Meglio se navighi in incognito. Fai la
      ricerca con i campi giusti (nome struttura, ospiti, età bambini, data
      arrivo e partenza), vedrai nei risultati di ricerca la struttura da te
      selezionata come primo risultato ed evidenziato in celeste. Utilizza il
      link di quella pagina (che ha questa forma:
      https://www.booking.com/searchresults.it.html?.......).<br />Per
      approfondire e vedere un esempio
      <a
        href="https://docs.google.com/document/d/1_F0--5O1lB6cr3J2Zbe5qWlX9zdg_9CJk47hEWFfbDA"
        target="_blank"
        >consulta la guida</a
      >.</small
    >
  </p>
</app-empty-list-message>

<mat-accordion>
  <mat-expansion-panel
    *ngFor="
      let accomodation of itinerary.reservations.accomodations;
      index as accomodationId
    "
    [(expanded)]="expanded[accomodationId]"
  >
    <mat-expansion-panel-header>
      <mat-panel-title fxLayoutAlign="start center">
        <mat-icon class="header-icon">hotel</mat-icon>
        <span class="header-title" fxFlex>
          <app-itinerary-reservations-accomodation-form-title
            [accomodation]="accomodation"
          ></app-itinerary-reservations-accomodation-form-title>
        </span>
        <div class="header-actions">
          <button
            mat-icon-button
            matTooltip="Rimuovi questa sistemazione"
            (click)="removeAccomodation($event, accomodation)"
            *ngIf="
              !itineraryService.isItineraryReadOnlyForCurrentUser(itinerary)
            "
          >
            <mat-icon aria-label="Rimuovi">delete</mat-icon>
          </button>
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <app-itinerary-reservations-accomodation-form
      [accomodation]="accomodation"
      [accomodationId]="accomodationId"
      [npax]="itinerary.npax"
      [disabled]="itineraryService.isItineraryReadOnlyForCurrentUser(itinerary)"
    ></app-itinerary-reservations-accomodation-form>
  </mat-expansion-panel>
</mat-accordion>
